import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Modal } from '../../ui/kit/components/overlays';
import { Button } from '../../ui/kit/components/primitives';
import { BILLING_BLOCKED_EVENT, type BillingBlock } from '../../lib/billingGate';

const COPY: Record<BillingBlock['code'], { title: string; fallback: string; action: string; target: string }> = {
  PLAN_REQUIRED: {
    title: 'Choose a plan to start',
    fallback: 'Generation is off until the studio picks a plan.',
    action: 'Choose a plan',
    target: '/pricing'
  },
  CREDITS_EXHAUSTED: {
    title: 'Out of credits',
    fallback: 'This studio has used its credits for the period. Nothing was queued and nothing was charged.',
    action: 'Add credits',
    target: '/pricing#credit-studio-title'
  }
};

export default function BillingGate({ canPurchase }: { canPurchase: boolean }) {
  const navigate = useNavigate();
  const [block, setBlock] = useState<BillingBlock | null>(null);

  useEffect(() => {
    const onBlocked = (event: Event) => setBlock((event as CustomEvent<BillingBlock>).detail);
    window.addEventListener(BILLING_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(BILLING_BLOCKED_EVENT, onBlocked);
  }, []);

  const copy = block ? COPY[block.code] : null;
  const close = () => setBlock(null);
  const go = () => { const target = copy?.target || '/pricing'; close(); navigate(target); };

  return <Modal
    open={Boolean(block && copy)}
    onOpenChange={open => { if (!open) close(); }}
    title={copy?.title || ''}
    size="sm"
    footer={<>
      <Button variant="ghost" onClick={close}>Not now</Button>
      <Button variant="primary" onClick={go}>{canPurchase ? copy?.action : 'See plans'}</Button>
    </>}
  >
    <p>{block?.message || copy?.fallback}</p>
    {!canPurchase && <p className="bs-muted">Only the studio owner can buy credits or change the plan. Ask them to top up.</p>}
  </Modal>;
}
